export const deleteProfilePath = '/delete-account'

export const finalProfileDeletePath = '/final-account-delete'

export interface FinalAccountDeleteParams {
  reason: string
}
export const finalProfileDeleteFullPath = '/final-account-delete/:reason'
